import { type JSX } from 'react'

import { SelectListbox, type SelectListboxProps } from 'base-ui'

import { ProductSearchRefinementCheckboxListboxBody } from './ProductSearchRefinementCheckboxListboxBody'

export const ProductSearchRefinementCheckboxListbox = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>(
  props: SelectListboxProps<OptionValue, Multiple>,
): JSX.Element => (
  <SelectListbox
    {...props}
    slots={{ body: ProductSearchRefinementCheckboxListboxBody }}
  />
)
